import { PERMISSIONS } from "../../app/utils/Permissions";

const P = PERMISSIONS.TRANSPORTADORA;

import { Constants } from '../../app/utils/Constants';

export default {
    header: {
        self: {},
        items: [
            {
                title: "Suporte via WhatsApp",
                root: true,
                alignment: "left",
                link: Constants.whatsappLink,
                icon: "fab fa-whatsapp",
            },
        ]
    },
    aside: {
        self: {},
        items: [
            {
                title: "Dashboard",
                root: true,
                icon: "fas fa-tachometer-alt",
                page: "transportador/dashboard",
                permission: P.DASHBOARD_VIEW,
                bullet: "dot"
            },
            {
                title: "Painel de Ofertas",
                root: true,
                icon: "fas fa-dollar-sign",
                bullet: "dot",
                submenu: [
                    {
                        title: "Ofertas",
                        bullet: "dot",
                        page: "transportador/painel-oferta",
                    },
                    {
                        title: "Meus Fretes",
                        bullet: "dot",
                        page: "transportador/painel-oferta/meus-fretes",
                    },
                ]
            },
            {
                title: "Programações",
                root: true,
                bullet: "dot",
                icon: "fas fa-tags",
                submenu: [
                    {
                        title: "Gestão Operacional",
                        bullet: "dot",
                        page: "transportador/frete",
                permission: P.PROGRAMACAO_LIST,
                    },
                    {
                        title: "Agendamentos",
                        bullet: "dot",
                        page: "transportador/agendamento",
                permission: P.AGENDAMENTO_LIST
                    },
                    {
                        title: "Planejamento",
                        bullet: "dot",
                        page: "transportador/frete/calendario",
                permission: P.LOTE_LIST,
                    },
                ]
            },
            // {
            // 	title: "Agendamentos de Fretes",
            // 	root: true,
            // 	icon: "fas fa-calendar",
            // 	page: "transportador/agendamento",
            // 	bullet: "dot"
            // },
            // {
            // 	title: "Confirmação Faturados",
            // 	root: true,
            // 	icon : "fas fa-money-bill-wave",
            // 	page: "transportador/faturados",
            // 	bullet: "dot"
            // },
            // {
            // 	title: "Orçamentos",
            // 	root: true,
            // 	icon: "fas fa-file-contract",
            // 	page: "transportador/orcamento",
            // 	bullet: "dot"
            // },
            // {
            // 	title: "Ofertas",
            // 	root: true,
            // 	bullet: "dot",
            // 	icon: "fas fa-tags",
            // 	submenu: [
            // 		{
            // 			title: "Aceitas",
            // 			bullet: "dot",
            // 			page: "transportador/oferta/aceita"
            // 		},
            // 		{
            // 			title: "Pendentes",
            // 			bullet: "dot",
            // 			page: "transportador/oferta/pendente"
            // 		},
            // 	]
            // },
            // {
            // 	title: "Avaliações",
            // 	root: true,
            // 	bullet: "dot",
            // 	icon: "fas fa-truck-loading",
            // 	submenu: [
            // 		{
            // 			title: "Respondidos",
            // 			bullet: "dot",
            // 			page: "transportador/avaliacao/ativas"
            // 		},
            // 		{
            // 			title: "Pendentes",
            // 			bullet: "dot",
            // 			page: "transportador/avaliacao/pendentes"
            // 		},
            // 	]
            // },
            // {
            // 	title: "Pátio",
            // 	root: true,
            // 	bullet: "dot",
            // 	icon: "fas fa-parking",
            // 	submenu: [
            // 		{
            // 			title: "Dashboard",
            // 			bullet: "dot",
            // 			page: "transportador/patio/dashboard"
            // 		},
            // 		{
            // 			title: "Serviços",
            // 			bullet: "dot",
            // 			submenu: [
            // 				{
            // 					title: "Limpeza",
            // 					bullet: "dot",
            // 					page: "transportador/patio/comprar/limpeza"
            // 				},
            // 				{
            // 					title: "Estacionamento",
            // 					bullet: "dot",
            // 					page: "transportador/patio/comprar/estacionamento"
            // 				},
            // 				{
            // 					title: "Classificação de Produto",
            // 					bullet: "dot",
            // 					page: "transportador/patio/comprar/classificacao"
            // 				},
            // 			]
            // 		},
            // 		{
            // 			title: "Relatórios",
            // 			bullet: "dot",
            // 			submenu: [
            // 				{
            // 					title: "Cobrança",
            // 					bullet: "dot",
            // 					page: "transportador/patio/relatorio/relatorio01"
            // 				},
            // 			]
            // 		},
            // 	]
            // },
            {
                title: "Relatórios",
                root: true,
                bullet: "dot",
                icon: "fas fa-chart-pie",
                submenu: [
                    {
                        title: "Transporte",
                        bullet: "dot",
                        page: "transportador/relatorio/relatorio01",
                permission: P.RELATORIO_LIST
                    },
                    {
                        title: "Volume de cargas por região",
                        bullet: "dot",
                        page: "transportador/relatorio/relatorio02",
                permission: P.RELATORIO_LIST
                    },
                ]
            },
            {
                title: "Cadastros",
                root: true,
                icon: "fas fa-city",
                bullet: "dot",
                submenu: [
                    {
                        title: "Motorista",
                        page: "transportador/motorista",
                permission: P.CAMINHONEIRO_LIST,
                        bullet: "dot",
                    },
                    {
                        title: "Tração",
                        page: "transportador/tracao",
                permission: P.UNIDADE_TRACAO_LIST,
                        bullet: "dot"
                    },
                    {
                        title: "Carroceria",
                        page: "transportador/carroceria",
                permission: P.UNIDADE_CARGA_LIST,
                        bullet: "dot"
                    },
                    {
                        title: "Proprietário ANTT",
                        page: "transportador/proprietario-antt",
                permission: P.PROPRIETARIO_ANTT_LIST,
                        bullet: "dot"
                    },
                ]
            },
            {
                title: "Minhas Placas",
                root: true,
                icon: "fas fa-id-card",
                page: "transportador/minhas-placas",
                permission: [P.UNIDADE_TRACAO_LIST, P.UNIDADE_CARGA_LIST],
                bullet: "dot"
            },
        ]
    }
};
